import React from 'react';
import { PaymentData } from '../types';
import { useLanguage } from '../i18n/LanguageProvider';

interface UserInfoProps {
  userData: PaymentData | null;
}

const UserInfo: React.FC<UserInfoProps> = ({ userData }) => {
  const { t } = useLanguage();
  if (!userData) return null;

  return (
    <div className="pp-section-wrap">
      <div className="pp-panel-header">
        <span>{t('payerInfo')}</span>
      </div>
      <div className="pp-user-panel">
        {(userData.firstName || userData.lastName) && (
          <div className="pp-user-name">{userData.firstName} {userData.lastName}</div>
        )}
        {(userData.legalPersonName) && (
          <div className="pp-user-name">{userData.legalPersonName}</div>
        )}
        {userData.userEmail && (
          <div>
            <a href={`mailto:${userData.userEmail}`} className="pp-link">
              {userData.userEmail}
            </a>
          </div>
        )}
        {userData.userPhone && (
          <div>
            <a href={`tel:${userData.userPhone}`} className="pp-link">
              {userData.userPhone}
            </a>
          </div>
        )}
        {userData.userAddress && <div>{userData.userAddress}</div>}
        {userData.userCity && <div>{userData.userCity}</div>}
        {userData.userPostalCode && <div>{userData.userPostalCode}</div>}
        {userData.userCountry && <div>{userData.userCountry}</div>}
      </div>
    </div>
  );
};

export default UserInfo;